import { useEffect, useMemo, useState } from "react";
import {
  getCardAudienceOptions,
  vendorCardNeedsAudience,
} from "./catalogCard";

export default function useCatalogCardExport({
  isVendor,
  brandData,
  materialKey,
  exportCard,
}) {
  const [pendingAction, setPendingAction] = useState(null);
  const [step, setStep] = useState("format");
  const options = useMemo(
    () => getCardAudienceOptions(brandData),
    [brandData],
  );
  const needsChooser = Boolean(isVendor && vendorCardNeedsAudience(brandData));

  useEffect(() => {
    setPendingAction(null);
    setStep("format");
  }, [materialKey]);

  const reset = () => {
    setPendingAction(null);
    setStep("format");
  };

  return {
    pendingAction,
    step,
    options,
    requestExport: (action) => {
      setPendingAction(action);
      setStep("format");
    },
    confirmFormat: (format) => {
      if (!pendingAction) {
        return;
      }
      if (format === "named") {
        const action = pendingAction;
        reset();
        exportCard(action, { format: "named" });
        return;
      }
      if (needsChooser) {
        setStep("audience");
        return;
      }
      const action = pendingAction;
      reset();
      exportCard(action, { format: "card", audience: null });
    },
    confirmAudience: (audience) => {
      if (!pendingAction) {
        return;
      }
      const action = pendingAction;
      reset();
      exportCard(action, { format: "card", audience });
    },
    backToFormat: () => setStep("format"),
    cancelAudience: reset,
  };
}
